import clsx from 'clsx'
import isEmpty from 'lodash/isEmpty'
import React, { FC, useContext, useEffect } from 'react'
import styled from 'styled-components'

import { PreviousSearches } from '@Components/Search/PreviousSearches'
import { QueryResults } from '@Components/Search/QueryResults'
import { SearchContext } from '@Globals/Search/Context'
import { up } from '@Globals/Style/breakpoints'
import { sectionOuter } from '@Globals/Style/mixins'

interface SearchResultsProps {
  onBackdropChange: (isOpen: boolean) => void
}

const StyledWrapper = styled.div`
  display: none;

  ${up('desktop')} {
    position: absolute;
    ${sectionOuter};
    left: 0;
    z-index: ${({ theme }) => theme.zIndexes.desktopHeaderNavMenu};
  }
`

export const DesktopSearchResults: FC<SearchResultsProps> = ({
  onBackdropChange,
}: SearchResultsProps) => {
  const {
    active,
    previousSearches,
    query,
    results,
    selection,
    setActive,
  } = useContext(SearchContext)

  const hasQuery = active && query?.length >= 2
  const hasPreviousSearches = active && !isEmpty(previousSearches)

  useEffect(() => {
    if (hasQuery) {
      onBackdropChange(true)
      return
    }

    if (hasPreviousSearches) {
      onBackdropChange(true)
      return
    }

    onBackdropChange(false)
  }, [hasQuery, hasPreviousSearches, onBackdropChange])

  if (hasQuery) {
    return (
      <StyledWrapper
        className={clsx('-j-desktop-header-search-wrap')}
        onClick={() => setActive(false)}
      >
        <QueryResults query={query} results={results} selection={selection} />
      </StyledWrapper>
    )
  }

  if (hasPreviousSearches) {
    return (
      <StyledWrapper
        className={clsx('-j-desktop-header-search-wrap')}
        onClick={() => setActive(false)}
      >
        <PreviousSearches previousSearches={previousSearches} selection={selection} />
      </StyledWrapper>
    )
  }

  return null
}
